import cn from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { useCurrencyFormatter } from 'src/localization/Crncy'
import { useTranslate } from 'src/localization/Trns'
import { TransactionListModel } from 'src/models/transaction.models'
import { useQueryExpenseCategories } from 'src/queries/organizations/expenseCategories.queries'
import { selectOrganizationReceiptMgmtEnabledFromState } from 'src/redux/selectors/data/organizations.selectors'
import { selectActiveOrgIntegration } from 'src/redux/selectors/data/orgIntegrations.selectors'
import { toDollars } from 'src/utils/currency.utils'

import style from './TaskItem.style'

interface TaskItemProps {
  task: TransactionListModel
}

const TaskItem = ({ task }: TaskItemProps): React.ReactElement => {
  const translate = useTranslate()
  const currencyFormatter = useCurrencyFormatter()

  let missingCopy

  // check for required receipts that are missing
  const receiptManagementEnabled = useSelector(
    selectOrganizationReceiptMgmtEnabledFromState,
  )
  const receiptsMissing =
    receiptManagementEnabled &&
    task.attachmentsCount === 0 &&
    task.receiptRequired
  if (receiptsMissing) {
    missingCopy = translate('Missing Receipt')
  }

  // check for required exp cats that are missing
  const { data: mandatoryExpenseDetails } = useQueryExpenseCategories({
    filters: { active: true, requiredForTransactions: true },
  })
  const activeIntegration = useSelector(selectActiveOrgIntegration)
  const expCatsMissing =
    task.isCleared &&
    task.checkMissingRequiredExpenseCategory(
      activeIntegration?.connectedPlatform,
      mandatoryExpenseDetails,
    )
  if (expCatsMissing) {
    missingCopy = translate('Missing Expense Categories')
  }

  // are both missing?
  if (expCatsMissing && receiptsMissing) {
    missingCopy = translate('Missing Expense Categories & Receipt')
  }

  return (
    <div className={cn('TaskItem', task.id)} css={style}>
      <div className={cn('TaskItem-title')}>
        {translate('Transaction for ${amount} from ${merchant}', {
          merchant: task.merchantName?.toUpperCase() || '',
          amount: currencyFormatter({
            amount: toDollars(task.clearingBillingAmountCents || 0),
            currency: task.clearingBillingCurrency,
          }),
        })}
      </div>
      <div className={cn('TaskItem-body')}>{missingCopy}</div>
    </div>
  )
}

export default TaskItem
